import { SIZE_FULL } from '@/lib/gridElements/size';

import { MediasWidget } from '@/components/pages/analyze/widget/MediasWidget';

export const mostRecentPostsConfig = {
    title: 'chart.linkedin.widget_most_recent_posts',
    id: 'widget_most_recent_posts',
    size: SIZE_FULL,
    sortFields: [
        'created',
        'engagement_rate',
        'likes',
        'comments',
        'shares',
        'impressions',
        'clicks',
        'reach'
    ],
    type: 'widget',
    element: MediasWidget
};
